import { useCallback, useState } from "react";
import { isNil } from "lodash";

import { Box, Stack, Typography } from "@mui/material";
import { Button } from "@covertree/ui";
import type { UnderwritingStatus } from "@covertree/new-business-graphql";

import { UnderwritingReasonsModal } from "../modals/UnderwritingReasonsModal";

interface DeclinePropertyProps {
  isD2C?: boolean;
  goBack?: () => void;
  underwritingDecision?: UnderwritingStatus;
}

export function DeclineProperty({
  isD2C = false,
  goBack,
  underwritingDecision,
}: DeclinePropertyProps) {
  const [isReasonsModalOpen, setReasonsModalOpen] = useState(false);

  const toggleReasonsOpen = useCallback(
    () => setReasonsModalOpen((prevValue) => !prevValue),
    []
  );

  const handleGoBack = useCallback(() => {
    if (goBack) goBack();
  }, [goBack]);

  return (
    <Stack>
      <Box mb={5}>
        <Typography data-testid="decline-property-header" variant="h3">
          <>
            <img
              src="/images/decline-property/decline-property.webp"
              alt="decline property"
            />
            <br />
            Sorry, your property is not eligible because it’s outside of our
            current offering.
          </>
        </Typography>
      </Box>

      <Box>
        {isD2C ? (
          <Button onClick={handleGoBack}>Go to covertree.com</Button>
        ) : (
          <Button disabled={!underwritingDecision} onClick={toggleReasonsOpen}>
            View reason
          </Button>
        )}
      </Box>

      {!!underwritingDecision && (
        <UnderwritingReasonsModal
          status={underwritingDecision.decision}
          reasons={
            (underwritingDecision.notes?.filter((note) => !isNil(note)) ||
              []) as string[]
          }
          open={isReasonsModalOpen}
          onClose={toggleReasonsOpen}
        />
      )}
    </Stack>
  );
}
